import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiCommonService } from '@api-services/api-common.service';
import { COMPANY_API_ROUTE_BASE } from '@constants/api-routes.constant';
import { ApiAlertError } from '@decorators/api-alert-error';
import { ExternalLink, ExternalLinkJson } from '@models/external-link';

@Injectable({
  providedIn: 'root'
})
export class ExternalLinkApiService extends ApiCommonService<ExternalLink> {
  readonly resourceUrl: string = `${COMPANY_API_ROUTE_BASE}/external_links`;

  fromJson(json: ExternalLinkJson): ExternalLink {
    return ExternalLink.fromJson(json);
  }

  toJson(model: ExternalLink): ExternalLinkJson {
    return ExternalLink.toJson(model);
  }

  @ApiAlertError()
  getExternalLinks(): Observable<ExternalLink[]> {
    return this.getAll();
  }

  @ApiAlertError()
  createExternalLink(externalLink: ExternalLink): Observable<ExternalLink> {
    return this.create(externalLink);
  }

  @ApiAlertError()
  updateExternalLink(externalLink: ExternalLink): Observable<ExternalLink> {
    return this.update(externalLink.id, externalLink);
  }

  @ApiAlertError()
  deleteExternalLink(externalLinkId: number): Observable<unknown> {
    return this.delete(externalLinkId);
  }
}
